import React from "react";
import './post.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { Typography } from "@mui/material";
import { MEDIA_QUESTIONBOX } from "../preview/medias/types.js";

const PostTab = ({ post, isActive, onClose, onSelect }) => {

  const getPostTabTitle = () => {
      if(post.event){
        return post.event?.tab
      }

      if(post.observer){
        switch(post.observer.type){
          case MEDIA_QUESTIONBOX : 
            return "Questions"
          default : 
            return "POST"
        }
      }
  }

  return (
    <div className={`tab ${isActive ? "active" : ""}`} onClick={onSelect}>
      <Typography 
        sx={{minWidth: '90px',
        textAlign: 'center', paddingLeft: '5px'}}>
          {getPostTabTitle()}
        </Typography>
      <button className="post-close-btn" onClick={(e) => { e.stopPropagation(); onClose(); }}>
        <FontAwesomeIcon icon={faClose}></FontAwesomeIcon>  
      </button>
    </div>
  );
};

export default PostTab;
